import React from "react";
import {
  UnorderedList,
  Text,
  Box,
  Checkbox,
  Flex,
  ListItem,
} from "@chakra-ui/react";
import FormListItem from "./FormListItem";
import { formatDate } from "./utils";
import Header from "./Header";
const FormList = ({
  templates,
  onClickPreviewHandler,
  onChangeCheckBox,
  isChecked,
  allChecked,
  selectValue,
  onChangeEvent,
  onClickEvent,
}) => {
  const renderForms = () => {
    const formsJSX = templates.map(({ title, created, id }, index) => {
      return (
        <FormListItem
          key={index}
          title={title}
          onClickPreviewHandler={onClickPreviewHandler}
          onChangeCheckBox={onChangeCheckBox}
          isChecked={isChecked}
          allChecked={allChecked}
          templateId={id}
          created={formatDate(created)}
        />
      );
    });
    return formsJSX;
  };
  return (
    <div>
      {!templates.length ? (
        <Text>No forms was created yet!</Text>
      ) : (
        <div>
          <Flex paddingTop="12px" paddingBottom="10px">
            <Header
              selectValue={selectValue}
              onChangeEvent={onChangeEvent}
              onClickEvent={onClickEvent}
            />
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "right",
                alignItems: "center",
              }}
            >
              {templates.length} items
            </Box>
          </Flex>
          <UnorderedList
            marginStart="0"
            className="form-list"
            borderRadius="4px"
            bg="#fff"
            styleType="none"
            border="1px solid #c3c4c7"
          >
            <ListItem className="form-list-item" w="100%">
              <Flex justify="space-between" w="100%">
                <Flex p="12px" alignItems="center">
                  <Checkbox
                    isChecked={allChecked}
                    onChange={(e) => {
                      onChangeCheckBox(e, "mainCheckBox");
                    }}
                  ></Checkbox>
                </Flex>
                <Box p="3" w="58%">
                  <Text color="#3871AC">Name</Text>
                </Box>
                <Box p="3" w="32%">
                  <Text>Shortcode</Text>
                </Box>
                <Box p="3" w="10%" color="#3871AC">
                  <Text>Created</Text>
                </Box>
              </Flex>
            </ListItem>
            {renderForms()}
            <ListItem className="form-list-item" w="100%">
              <Flex justify="space-between" w="100%">
                <Flex p="12px" alignItems="center">
                  <Checkbox
                    isChecked={allChecked}
                    onChange={(e) => {
                      onChangeCheckBox(e, "mainCheckBox");
                    }}
                  ></Checkbox>
                </Flex>
                <Box p="3" w="58%">
                  <Text color="#3871AC">Name</Text>
                </Box>
                <Box p="3" w="32%">
                  <Text>Shortcode</Text>
                </Box>
                <Box p="3" w="10%" color="#3871AC">
                  <Text>Created</Text>
                </Box>
              </Flex>
            </ListItem>
          </UnorderedList>
          <Flex paddingTop="10px">
            <Header
              selectValue={selectValue}
              onChangeEvent={onChangeEvent}
              onClickEvent={onClickEvent}
            />
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "right",
                alignItems: "center",
              }}
            >
              {templates.length} items
            </Box>
          </Flex>
        </div>
      )}
    </div>
  );
};

export default FormList;
